(() => {
  if (window.SOPGiftWrap) return;
  const root = window.Shopify?.routes?.root || '/';
  const linkProperty = '_sop_gift_wrap';
  /** Identify the configured gift-box product in a cart or add request. */
  const isGift = (item) => String(item.variant_id || item.id) === '39314992595122' ||
    item.handle === 'gift-box-lilly-pulitzer-1' || item.properties?._sop_gift_box === 'true';

  // Gift Wrap Plus adds the box with jQuery/XHR before submitting the product form.
  // Give both lines a private reference without replacing the app's note/From/To data.
  const open = XMLHttpRequest.prototype.open;
  const send = XMLHttpRequest.prototype.send;
  /** Track cart-add requests while preserving native XHR arguments and return values. */
  XMLHttpRequest.prototype.open = function (method, url) {
    this.sopGiftAdd = String(method).toUpperCase() === 'POST' &&
      /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url));
    return open.apply(this, arguments);
  };
  /** Link the app gift-box add and product form with a shared private reference. */
  XMLHttpRequest.prototype.send = function (body) {
    if (this.sopGiftAdd && typeof body === 'string') {
      const data = new URLSearchParams(body);
      const checkbox = document.querySelector('#NullsgiftWrap');
      const form = checkbox?.form;
      if (isGift({ id: data.get('id') }) && checkbox?.checked && form) {
        const reference = crypto.randomUUID();
        let input = form.querySelector(`[name="properties[${linkProperty}]"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${linkProperty}]`;
          form.append(input);
        }
        input.disabled = false;
        input.value = reference;
        data.set(`properties[${linkProperty}]`, reference);
        body = data.toString();
      }
    }
    return send.call(this, body);
  };

  /** Disable the completed reference so later unwrapped adds cannot inherit it. */
  const clearReference = () => document.querySelectorAll(`[name="properties[${linkProperty}]"]`)
    .forEach((input) => { input.disabled = true; });
  document.addEventListener('theme:cart-add', clearReference);
  document.addEventListener('change', (event) => {
    if (event.target.id === 'NullsgiftWrap' && !event.target.checked) clearReference();
  });

  /** Build removals for gift boxes without a matching product, using titles for legacy carts. */
  const orphanUpdates = (items) => {
    const products = items.filter((item) => !isGift(item));
    const references = new Set(products.map((item) => item.properties?.[linkProperty]).filter(Boolean));
    const titles = new Set(products.map((item) => item.product_title));
    return Object.fromEntries(items.filter((item) => {
      if (!isGift(item)) return false;
      const reference = item.properties?.[linkProperty];
      if (reference) return !references.has(reference);
      const title = item.properties?.For;
      return products.length === 0 || (title && !titles.has(title));
    }).map((item) => [item.key, 0]));
  };

  // Run only after a cart quantity/removal request, never between the app's
  // separate gift and product adds. Return freshly rendered sections as well.
  /** Apply a cart change once, retry orphan cleanup up to three times, and return updated sections. */
  const change = async (url, config) => {
    const response = await fetch(url, config);
    if (!response.ok) return response;
    const cart = await response.clone().json();
    if (cart.errors || !Array.isArray(cart.items)) return response;
    const updates = orphanUpdates(cart.items);
    if (!Object.keys(updates).length) return response;
    const request = JSON.parse(config.body);
    const cleanupBody = JSON.stringify({ updates, sections: request.sections, sections_url: request.sections_url });
    // Only retry the idempotent cleanup, never the customer's original cart change.
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        const cleaned = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: cleanupBody
        });
        if (cleaned.ok) return cleaned;
      } catch (error) {
        // Network failures use the same bounded retry as unsuccessful responses.
      }
    }
    throw new Error('Unable to remove the associated gift wrap. Please retry.');
  };
  window.SOPGiftWrap = { isGift, change };
})();
